import React from 'react'
import { Value } from '@gitbook/slate'
import { State, HTMLParser } from 'markup-it';
import { memoize } from 'lodash'


const htmlRenderer = State.create(HTMLParser);

export default class Description extends React.PureComponent {
  renderDocument = memoize(
    (description) => {
      let value = Value.create();
      if(description) {
        try {
          value = Value.fromJSON(JSON.parse(description))
        } catch(e) {

        }
      }

      return htmlRenderer.serializeDocument(value.document);
    }
  );


  render() {
    const { description } = this.props;
    const str = this.renderDocument(description);

    return <div dangerouslySetInnerHTML={{__html: str }} />
  }
}
